export const getUnitCirclePoint = (angle) => {
   const radAngle = (angle * Math.PI) / 180;
   return [Math.sin(radAngle), Math.cos(radAngle)];
};
